'use client';

export { default } from './AvatarGroup';
export { default as avatarGroupClasses } from './avatarGroupClasses';
export * from './avatarGroupClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/AvatarGroup/index.js
// module id = 817
// module chunks = 22